/*
 ** vue router: Attendance
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtAttendance: RouteRecordRaw = {
  path: '/eservices/attendance',
  name: 'vrtAttendance',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'create',
      name: 'vrtAttendanceCreate',
      component: () => import('./vpgAttendanceCreate.vue'),
    },
    {
      path: 'reset',
      name: 'vrtAttendanceReset',
      component: () => import('./vpgAttendanceReset.vue'),
    },
    {
      path: 'update',
      name: 'vrtAttendanceUpdate',
      component: () => import('./vpgAttendanceUpdate.vue'),
    },
    {
      path: 'report',
      name: 'vrtAttendanceReport',
      component: () => import('./vpgAttendanceReport.vue'),
    },
    {
      path: 'approve',
      name: 'vrtAttendanceApprove',
      component: () => import('./vpgAttendanceApprove.vue'),
    },
  ],
};

export default vrtAttendance;
